<template>
  <div class="operate" :class="getSize">
    <img :src="getStatus" />
    <div class="box top" @mousedown="startPress('top')" @mouseup="stopPress" @mouseleave="stopPress" @touchstart="startPress('top')" @touchend="stopPress" @mouseover="isTop = true" @mouseout="isTop = false"></div>
    <div class="box bottom" @mousedown="startPress('bottom')" @mouseup="stopPress" @mouseleave="stopPress" @touchstart="startPress('bottom')" @touchend="stopPress" @mouseover="isBottom = true" @mouseout="isBottom = false"></div>
    <div class="box left" @mousedown="startPress('left')" @mouseup="stopPress" @mouseleave="stopPress" @touchstart="startPress('left')" @touchend="stopPress" @mouseover="isLeft = true" @mouseout="isLeft = false"></div>
    <div class="box right" @mousedown="startPress('right')" @mouseup="stopPress" @mouseleave="stopPress" @touchstart="startPress('right')" @touchend="stopPress" @mouseover="isRight = true" @mouseout="isRight = false"></div>
    <div class="center" @click="center" @mouseover="hover = true" @mouseout="hover = false"></div>
  </div>
</template>

<script>
export default {
  name: 'operateBtn',
  props: {
    id: Number,
    status: String,
    unable: String,
    size: Number
  },
  data() {
    return {
      url: 'https://media.tp-link.com.cn/webresource/act/vr/images/icon/ptz2/',
      hover: false,
      isTop: false,
      isLeft: false,
      isBottom: false,
      isRight: false,
      pressInterval: null,
      lastEmitTime: 0,
      debounceDelay: 500 // 0.5 seconds
    }
  },
  computed: {
    getStatus() { 
      let url = this.url + this.status
      
      if(this.hover){
        return url + '_hover.png'
      }else if(this.isTop){
        if(this.unable == 'top'){
          url = url + '_unable'
        }
        return url +  '_up.png'
      }else if(this.isLeft){
        if(this.unable == 'left'){
          url = url + '_unable'
        }
        return url +  '_left.png'
      }else if(this.isBottom){
        if(this.unable == 'bottom'){
          url = url + '_unable'
        }
        return url +  '_down.png'
      }else if(this.isRight){
        if(this.unable == 'right'){
          url = url + '_unable'
        }
        return url +  '_right.png'
      }else{
        return url +  '.png'
      }
    },
    getSize(){
      return 'size' + this.size
    }
  },
  mounted() {

  },
  updated() {

  },
  methods: {
    startPress(direction) {
      // Emit the event immediately on first press
      this.emitDirectionEvent(direction);
      
      // Clear any existing interval
      if (this.pressInterval) {
        clearInterval(this.pressInterval);
      }
      
      // Start repeating with debounce
      this.pressInterval = setInterval(() => {
        this.emitDirectionEvent(direction);
      }, 100); // Check more frequently but emit with debounce
    },
    
    stopPress() {
      if (this.pressInterval) {
        clearInterval(this.pressInterval);
        this.pressInterval = null;
      }
    },
    
    emitDirectionEvent(direction) {
      const currentTime = Date.now();
      // Only emit if enough time has passed since last emit
      if (currentTime - this.lastEmitTime >= this.debounceDelay) {
        this.$emit(direction);
        this.lastEmitTime = currentTime;
      }
    },
    
    top() {
      this.$emit('top')
    },
    bottom() {
      this.$emit('bottom')
    },
    left() {
      this.$emit('left')
    },
    right(){
      this.$emit('right')
    },
    center() {
      this.$emit('center')
    },
  },
  created() {
    //console.log(this.id)
  },
  beforeUnmount() {
    // Clean up interval when component is destroyed
    this.stopPress();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "sass:math";

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}
.operate {
  width: px2vh(120);
  height: px2vh(120);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  &.size80{
    width: px2vh(80);
    height: px2vh(80);
  }

  img {
    width: 100%;
    display: block;
  }

  /* 通用盒子样式，绝对定位，设置居中相关属性，用于调整内容显示位置 */
  .box {
    position: absolute;
    width: 50%;
    height: 50%;
  }

  /* 上侧盒子，定位到容器顶部中间 */
  .top {
    left: 22.4%;
    top: -10%;
    transform: rotate(45deg);
  }

  /* 下侧盒子，定位到容器底部中间 */
  .bottom {
    left: 23%;
    bottom: -10%;
    transform: rotate(45deg);
  }

  /* 左侧盒子，定位到容器左侧中间 */
  .left {
    left: -10%;
    top: 23%;
    transform: rotate(45deg);
  }

  /* 右侧盒子，定位到容器右侧中间 */
  .right {
    right: -10%;
    top: 23%;
    transform: rotate(45deg);
  }

  /* 中间盒子，定位到容器中心 */
  .center {
    top: 27.9%;
    left: 27.2%;
    border-radius: 50%;
    width: 42.8%;
    height: 42.8%;
    position: absolute;
  }
}
</style>